import { Box, Stack, Typography } from '@mui/material';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { H5, Small } from '../../components/Typography';
import FlexBox from '../../components/flexbox/FlexBox';
import FlexRowAlign from '../../components/flexbox/FlexRowAlign';

const ProfileStatsCardMobile = ({ data = [] }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        padding: '20px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #f0f0f0',
      }}
    >
      <FlexBox
        sx={{
          alignItems: 'center',
          paddingBottom: '16px',
        }}
      >
        <img
          src="/static/logo/logo-2.svg"
          alt="profile"
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: '#4A90E2',
            marginRight: '8px',
            objectFit: 'contain',
          }}
        />
        <H5>홍길동</H5>
      </FlexBox>

      {/* Stats list - arranged in two rows */}
      <Stack spacing={2}>
        {/* First row: 내 글, 내 댓글 */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          {data.slice(0, 2).map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                flex: 1,
                justifyContent: 'space-between',
              }}
              onClick={() => navigate(item.path || '')}
            >
              <Small
                sx={{
                  fontSize: '16px',
                  color: '#333333',
                  fontWeight: 500,
                  marginRight: '8px',
                }}
              >
                {item.text}
              </Small>
              <FlexRowAlign>
                <Typography
                  sx={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: item.count > 0 ? '#4A90E2' : '#999999',
                    marginRight: '4px',
                  }}
                >
                  {item.count}
                </Typography>
                <Box marginBottom={'-8px'}>
                  <ChevronRight
                    color={item.count > 0 ? '#4A90E2' : '#999999'}
                  />
                </Box>
              </FlexRowAlign>
            </Box>
          ))}
        </Box>

        {/* Second row: 스크랩, 출처 */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          {data.slice(2, 4).map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                flex: 1,
                justifyContent: 'space-between',
              }}
              onClick={() => navigate(item.path || '')}
            >
              <Small
                sx={{
                  fontSize: '16px',
                  color: '#333333',
                  fontWeight: 500,
                  marginRight: '8px',
                }}
              >
                {item.text}
              </Small>
              <FlexRowAlign>
                <Typography
                  sx={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: item.count > 0 ? '#4A90E2' : '#999999',
                    marginRight: '4px',
                  }}
                >
                  {item.count}
                </Typography>
                <Box marginBottom={'-8px'}>
                  <ChevronRight
                    color={item.count > 0 ? '#4A90E2' : '#999999'}
                  />
                </Box>
              </FlexRowAlign>
            </Box>
          ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default ProfileStatsCardMobile;
